<template>
  <div class="fire-device tip-page">
    <div class="tip-page-top">
      <span>{{ data.tipsTitle || "设备信息" }} </span>
      <el-tooltip class="item" effect="dark" content="关闭" placement="top-start">
        <i @click="handleCloseTip" class="el-icon-close"></i>
      </el-tooltip>
    </div>
    <div class="tip-page-content">
      <el-row :span="24">
        <span v-if="data.subDeviceMark">
          <el-col :span="24">
            <div class="item-content">
              <label class="item-label">主机系统类型 ：</label>
              <span class="item-value">{{ data.deviceType | dic("SENU087") }}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="item-content">
              <label class="item-label">主机唯一标识号 ：</label>
              <span class="item-value">{{ data.parentThirdDeviceId }}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="item-content">
              <label class="item-label">部件名称 ：</label>
              <span class="item-value">{{ data.deviceName }}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="item-content">
              <label class="item-label">部件地址 ：</label>
              <span class="item-value">{{ data.mac }}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="item-content">
              <label class="item-label">部件类型 ：</label>
              <span class="item-value">{{ data.subDeviceMark | dic("SENU094") }}</span>
            </div>
          </el-col>
        </span>
        <span v-else>
          <el-col :span="24">
            <div class="item-content">
              <label class="item-label">设备类型：</label>
              <span class="item-value">{{ data.deviceType | dic("SENU087") }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="24">
            <div class="item-content">
              <label class="item-label">设备编号：</label>
              <span class="item-value">{{ data.thirdDeviceId }}</span>
            </div>
          </el-col> -->
          <el-col :span="24">
            <div class="item-content">
              <label class="item-label">设备名称：</label>
              <span class="item-value">{{ data.deviceName }}</span>
            </div>
          </el-col>
          <el-col
            :span="24"
            v-if="data.deviceType == 27 || data.deviceType == 28 || data.deviceType == 29"
          >
            <div class="item-content">
              <label class="item-label">消防型号：</label>
              <span class="item-value">{{ data.deviceVersion | dic("SENU095") }}</span>
            </div>
          </el-col>
          <el-col
            :span="24"
            v-if="data.deviceType == 27 || data.deviceType == 28 || data.deviceType == 29"
          >
            <div class="item-content">
              <label class="item-label">唯一标识号：</label>
              <span class="item-value">{{ data.thirdDeviceId }}</span>
            </div>
          </el-col>
        </span>
      </el-row>
    </div>
    <!-- 消防控制使用 -->
    <div class="tip-page-bottom" v-if="pageType == 'control' && !controlPageType">
      <el-button @click="equipmentOperation" v-if="data.deviceTypeId == 4" type="info">
        设备操作
      </el-button>
      <el-button type="info" v-if="data.deviceTypeId == 4" @click="showOperationData">
        运行数据
      </el-button>
      <el-button @click="alarmInfoList" v-if="data.deviceTypeId == 21" type="info">
        告警信息
      </el-button>
      <el-button @click="playVideo" v-if="data.deviceType == 18" type="info">
        查看视频
      </el-button>
    </div>
    <!-- 消防告警使用 -->
    <div class="tip-page-bottom" v-if="pageType == 'alarm'">
      <!-- <el-button @click="handleUpdateDevice" v-if="data.deviceTypeId == 4" type="info">
        信息修改
      </el-button> -->
      <!-- <el-button
        @click="equipmentOperation"
        v-if="
          data.deviceTypeId == 4 &&
          showGY &&
          (data.deviceType == '27' || data.deviceType == '28' || data.deviceType == '29')
        "
        type="info"
      >
        设备操作
      </el-button> -->
      <el-button
        type="info"
        v-if="data.deviceTypeId == 4 && showGY"
        @click="handAlarmControl"
      >
        告警抑制
      </el-button>
      <!-- <el-button
        type="info"
        v-if="data.deviceType != 36 && data.deviceTypeId == 4 && showGY"
        @click="showOperationData"
      >
        运行数据
      </el-button> -->
      <el-button
        @click="alarmInfoList"
        v-if="data.deviceTypeId == 21 && showGY"
        type="info"
      >
        告警信息
      </el-button>
      <el-button @click="playVideo" v-if="data.deviceType == 18" type="info">
        查看视频
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  // 该模块在消防模块楼栋图纸使用
  name: "canvasTip",
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    controlPageType: {
      type: Boolean,
      default: false,
    },
    showGY: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: "control",
    },
  },
  data() {
    return {
      labelSpan: 11,
      //   data: {}, //渲染数据
    };
  },
  mounted() {},
  methods: {
    playVideo(type = "live") {
      this.$app.AppInstance.handleMiniPlay({
        playType: "live",
        playTitle: this.data.deviceName || this.data.cameraName, //摄像机名称
        playId: this.data.thirdDeviceId || this.data.thirdCameraId, //摄像机id
      });
    },
    equipmentOperation() {
      this.$emit("equipmentOperation");
    },
    showOperationData() {
      this.$emit("showOperationData", this.data);
    },
    alarmInfoList() {
      this.$emit("alarmInfoList", this.data);
    },
    handleCloseTip() {
      this.$emit("tipClose");
    },
    handleUpdateDevice() {
      this.$emit("handleUpdateDevice");
    },
    handAlarmControl() {
      this.$emit("handAlarmControl", this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.flex-Between {
  display: flex;
  justify-content: space-between;
}
$bgcolor: rgba(30, 40, 64, 1);
.tip-page::before {
  content: "";
  position: absolute;
  top: -20px;
  left: calc(50% - 35px);
  border-width: 10px;
  border-style: solid;
  @include set_theme_color(border-bottom-color, top-menu-bg-color);
  border-color: transparent transparent transparent;
}
.tip-page {
  color: #fff;
  min-width: 350px;
  max-width: 395px;
  padding: 16px;
  height: auto;
  font-size: 15px;
  border-radius: 5px;
  @include set_theme_color(background-color, mapCanvas-panel-content);
  backdrop-filter: blur(2px);
  pointer-events: none;

  &-top {
    border-left: 5px solid #407aee;
    padding-left: 10px;
    height: 20px;
    line-height: 20px;
    @extend .flex-Between;
    i {
      cursor: pointer;
      font-size: 18px;
      color: #fff;
      position: absolute;
      width: 22px;
      height: 22px;
      top: 10px;
      right: 10px;
      pointer-events: all;
      padding: 2px;
      &:hover {
        background: $bgcolor;
        border-radius: 50%;
        -webkit-animation: rotation 5s linear infinite;
        animation: rotation 5s linear infinite;
      }
    }
  }
  &-content {
    // width: 480px;
    margin-top: 12px;
    .item-content {
      font-size: 14px;
      margin: 8px 0;
      display: flex;
      flex-direction: row;
    }
    .el-col {
      margin-right: 10px;
    }
    .item-label {
      // width: 80px;
    }
    .item-value {
      //   max-width: 220px;
    }
  }
  &-bottom {
    padding: 5px;
    text-align: center;
    pointer-events: all;
  }
}

@keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
